<template>
    <div :class="classes" v-on:click="clicked()">
        <span><slot></slot></span>
    </div>
</template>
<script>
export default {
  methods: {
    clicked () {
      this.$emit('clicked')
    }
  },
  data () {
    return {
      button_class: 'btn-disabled'
    }
  },
  props: ['button_status', 'selected'],
  watch: {
    button_status: function (val) {
      console.log('BTN CHNAGED TO: ' + val)
      if (val) {
        this.button_class = 'btn-enabled'
      } else {
        this.button_class = 'btn-disabled'
      }
    }
  },
  computed: {
    classes () {
      return {
        [this.button_class]: true,
        'btn-selected': this.selected
      }
    }
  },
  created () {
    if (this.button_status === 0) {
      this.button_class = 'btn-disabled'
    } else {
      this.button_class = 'btn-enabled'
    }
  }
}
</script>
<style>
    .btn-enabled{
        display: inline-block;
        border-top: 4px #b62626 solid;
        padding: 5px;
        border-radius: 4px;
        box-shadow: 0px 3px 3px 3px rgba(0, 0, 0, 0.4);
        transition: background-color 0.2s , border-color 0.2s;
        margin: 5px;
        min-width: 50px;
        user-select: none;
        cursor: pointer;
        color:white;
    }
    .btn-enabled:hover{
        background-color: #b62626;
        border-top: 4px rgb(255, 0, 0) solid;
    }
    .btn-selected{
        background-color: #b62626;
        border-top: 4px rgb(255, 0, 0) solid;
    }
    .btn-disabled{
        display: inline-block;
        border-top: 4px #4d4d4d solid;
        padding: 5px;
        border-radius: 4px;
        box-shadow: 0px 3px 3px 3px rgba(0, 0, 0, 0.4);
        transition: background-color 0.2s , border-color 0.2s;
        margin: 5px;
        min-width: 50px;
        user-select: none;
        cursor: default;
        color:rgb(105, 105, 105);
    }
</style>



// WEBPACK FOOTER //
// src/components/button_a.vue